<div class="professionals-registry-container">
  <!-- Breadcrumb -->
  <nav class="mb-4" aria-label="Breadcrumb">
    <p-breadcrumb
      styleClass="custom-breadcrumb"
      [model]="breadcrumbItems()"
      [home]="{ icon: 'pi pi-home', routerLink: '/axa/professionals-dashboard' }"
    >
    </p-breadcrumb>
  </nav>

  <!-- Page Header -->
  <section class="page-header" aria-labelledby="page-title">
    <div class="header-content">
      <div class="header-left">
        <i class="pi pi-user header-icon" aria-hidden="true"></i>
        <div class="header-text">
          <h1 id="page-title">Registro Fiduciari</h1>
          <p class="subtitle">Gestione e monitoraggio dei fiduciari</p>
        </div>
      </div>
    </div>
  </section>

  <!-- Reusable Table Component -->
  <app-registry-table
    [title]="tableTitle"
    [icon]="tableIcon"
    [columns]="columns"
    [data]="data()"
    [loading]="loading()"
    [showClearFiltersButton]="true"
    [initialFilters]="initialFilters()"
    [serverSideFilter]="true"
    (onDetailClick)="onDetailClick($event)"
    (onEditClick)="onEditClick($event)"
    (onFilterChange)="onTableFilterChange($event)"
    (onClearFilters)="onClearFilters()"
  >
    <p-button
      toolbar-extra
      label="Esporta"
      icon="pi pi-download"
      [outlined]="true"
      (onClick)="onExport()"
      ariaLabel="Esporta il registro fiduciari"
      [attr.title]="'Esporta il registro fiduciari'"
    ></p-button>
  </app-registry-table>

  <!-- Toast for notifications -->
  <p-toast position="top-right" role="status" aria-live="polite" aria-atomic="true" />
</div>

<!-- Export Dialog -->
<p-dialog
  header="Esporta Registro Fiduciari"
  [visible]="showExportDialog()"
  (visibleChange)="showExportDialog.set($event)"
  [modal]="true"
  [style]="{ width: '480px' }"
  [draggable]="false"
  [resizable]="false"
>
  <div class="flex flex-column gap-3 py-2">
    <p class="m-0 text-color-secondary">Seleziona la categoria di fiduciari da esportare:</p>
    <div class="flex flex-column gap-2">
      @for (option of exportCategoryOptions; track option.value) {
        <div
          class="flex align-items-center gap-3 p-3 border-round cursor-pointer export-option"
          [class.selected]="selectedExportCategory() === option.value"
          (click)="selectedExportCategory.set(option.value)"
          (keydown.enter)="selectedExportCategory.set(option.value)"
          (keydown.space)="selectedExportCategory.set(option.value)"
          tabindex="0"
          role="radio"
          [attr.aria-checked]="selectedExportCategory() === option.value"
        >
          <i
            class="pi"
            [class.pi-file-excel]="option.value !== 'PROFESSIONALS_ALBO'"
            [class.pi-list]="option.value === 'PROFESSIONALS_ALBO'"
            style="font-size: 1.2rem;"
            [style.color]="selectedExportCategory() === option.value ? '#00008F' : '#6b7280'"
            aria-hidden="true"
          ></i>
          <span class="font-medium">{{ option.label }}</span>
          @if (option.value === 'PROFESSIONALS_ALBO') {
            <span class="ml-auto text-xs text-color-secondary">(tutti i fogli)</span>
          }
        </div>
      }
    </div>
  </div>
  <ng-template pTemplate="footer">
    <button
      pButton
      type="button"
      label="Annulla"
      icon="pi pi-times"
      severity="secondary"
      [text]="true"
      (click)="showExportDialog.set(false)"
    ></button>
    <button
      pButton
      type="button"
      label="Esporta"
      icon="pi pi-download"
      [loading]="isExporting()"
      [disabled]="isExporting()"
      (click)="confirmExport()"
    ></button>
  </ng-template>
</p-dialog>
